import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useParams, withRouter } from 'react-router-dom';
import { CatalogForm } from '../../../../components/CatalogForm/CatalogForm';
import { ClienteService } from '../../../../services/ClienteService';
import Http from '../../../../Http';

export const ClienteApiConfig = ({ match, id: propId, onSave }) => {
  const routeParams = useParams() || {};
  const clientId = propId || match?.params?.id || routeParams?.id;

  const [statusList, setStatusList] = useState([]);

  useEffect(() => {
    let mounted = true;
    const fetchApiConfig = async () => {
      try {
        const res = await Http.get('cliente/form/api');
        if (mounted && res && !res.error && res.data?.status) {
          setStatusList(
            res.data.status.map((s) => ({
              value: String(s.id),
              label: `${s.id} - ${s.descripcion}`,
            }))
          );
        }
      } catch (err) {
        console.error('Error al cargar estatus de API para guías', err);
      }
    };
    fetchApiConfig();
    return () => {
      mounted = false;
    };
  }, []);

  const loadClientData = useCallback(async () => {
    if (!clientId) return null;
    try {
      const data = await ClienteService.obtenerDetalleCompleto(clientId);
      if (!data) return null;

      return {
        cliente_id_api_guia_status: data.cliente_id_api_guia_status ? String(data.cliente_id_api_guia_status) : '',
      };
    } catch (e) {
      console.error('Error al cargar configuración de API', e);
      return null;
    }
  }, [clientId]);

  const fields = useMemo(
    () => [
      {
        name: 'section_api',
        label: 'Configuración de Webhooks e Integración API',
        type: 'section',
        col: 12,
      },
      {
        name: 'cliente_id_api_guia_status',
        label: 'Estatus Predeterminado para Notificación de Guías',
        type: 'select',
        col: 12,
        options: statusList,
        placeholder: 'Seleccione un estatus para sincronización API',
        helperText: 'Estatus del ciclo de vida de la guía que detonará la notificación en los servicios externos del cliente',
      },
    ],
    [statusList]
  );

  const handleSubmit = useCallback(
    async (values) => {
      const payload = {
        id: clientId,
        ...values,
      };
      return await ClienteService.guardar(payload);
    },
    [clientId]
  );

  const handleSuccess = useCallback(
    (response) => {
      if (onSave) {
        onSave(response);
      }
    },
    [onSave]
  );

  return (
    <div className="space-y-4">
      <CatalogForm
        title="Configuración API"
        subtitle="Reglas y estatus para la integración de guías con sistemas externos"
        fields={fields}
        id={clientId}
        loadData={loadClientData}
        onSubmit={handleSubmit}
        onSuccess={handleSuccess}
        submitButtonText="Guardar Configuración API"
      />
    </div>
  );
};

export default withRouter(ClienteApiConfig);
